import { Component, ElementRef, ViewChild, OnInit, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { CoopServiceService } from '../../../services/Coop/coop-service.service';
import { ViewerService } from '../../../services/Viewer/viewer.service';
import { AuthenService } from '../../../services/Authen/authen.service';
import { FamerServiceService } from '../../../services/Fammer/famer-service.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import Swal from 'sweetalert2';
import { isPlatformBrowser } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import he from '@angular/common/locales/he';
declare var google: any;
declare var jQuery: any;

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_dataviz from "@amcharts/amcharts4/themes/dataviz";

import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { callable, session_year } from "src/app/components/callable";

@Component({
  selector: 'app-agri-insert',
  templateUrl: './agri-insert.component.html',
  styleUrls: ['./agri-insert.component.scss']
})
export class AgriInsertComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId, private zone: NgZone,
    private CoopServiceService: CoopServiceService,
    private AuthenService: AuthenService,
    private SpinnerService: NgxSpinnerService,
    private router: Router,
    private ViewerService: ViewerService,
    private FamerServiceService: FamerServiceService,
  ) { }



  PhakId: any = "null";
  searchName_: any
  CoopNameTh: any
  CoopStatusProvinceYearBySearch: any
  CoopProfileAll: any
  coopId: any
  Info: any
  List: any
  OrgOrgId: any = "null";
  KhetId: any = "null";
  KhetId_: any
  PhakByKhet: any
  ProvinceByKhet: any
  PhakList: any
  groupkhet_bkk1: any
  groupkhet_bkk2: any
  checkkhet: any
  groupkhet_1: any
  Month_now_: any

  year_now: any;
  year_now_: any;
  Date_now: any;
  Date_after_day: any;
  Month_now: any;
  datayear: any;
  datayear_Lst: any;
  sumResult = 0
  CoopOracleCount = 0
  CoopOracleCountactive: any
  CoopOracleCountnonActive: any
  MemberSum = 0
  MemberDataM = 0
  MemberDataFm = 0
  CoopOfficerYearMember = 0
  CoopOfficerYearMemberM = 0
  CoopOfficerYearMemberFm = 0
  CommitteeSum = 0
  CommitteeSumM = 0
  CommitteeSumFm = 0
  selectPhak = false
  StandardTypeSum_pass: any = 0
  StandardTypeSum_notPass: any = 0

  StandardType_pass_level1: any
  StandardType_notPass_level1: any

  StandardType_pass_level2: any
  StandardType_notPass_level2: any

  StandardType_pass_level3: any
  StandardType_notPass_level3: any

  StandardType_pass_level4: any
  StandardType_notPass_level4: any

  StandardType_pass_level5: any
  StandardType_notPass_level5: any

  StandardType_pass_level6: any
  StandardType_notPass_level6: any

  StandardType_pass_level7: any
  StandardType_notPass_level7: any

  CoopOracleTypes: any;
  Active_coopType1: any = 0;
  InActive_coopType1: any = 0;
  typeName: any;
  valSum1: any = 0
  valSum2: any = 0
  valSum3: any = 0
  valSum4: any = 0
  valSum5: any = 0
  selectProviceSearch: any;
  listCoop: any;
  sumResult_: any;
  CoopStatusProvinceYearOne: any;
  pageOfItems: Array<any>;
  pageOfItemslistCoop: Array<any>;

  TypeAgri: any;
  TypeCoop: any;

  TypeLevelSum1: any = 0;
  TypeLevelSum2: any = 0;
  TypeLevelSum3: any = 0;
  TypeLevelSum4: any = 0;

  TypeLevel1_type1: any = 0;
  TypeLevel1_type2: any = 0;
  TypeLevel1_type3: any = 0;
  TypeLevel1_type4: any = 0;
  TypeLevel1_type5: any = 0;
  TypeLevel1_type6: any = 0;
  TypeLevel1_type7: any = 0;

  TypeLevel2_type1: any = 0;
  TypeLevel2_type2: any = 0;
  TypeLevel2_type3: any = 0;
  TypeLevel2_type4: any = 0;
  TypeLevel2_type5: any = 0;
  TypeLevel2_type6: any = 0;
  TypeLevel2_type7: any = 0;

  TypeLevel3_type1: any = 0;
  TypeLevel3_type2: any = 0;
  TypeLevel3_type3: any = 0;
  TypeLevel3_type4: any = 0;
  TypeLevel3_type5: any = 0;
  TypeLevel3_type6: any = 0;
  TypeLevel3_type7: any = 0;

  TypeLevel4_type1: any = 0;
  TypeLevel4_type2: any = 0;
  TypeLevel4_type3: any = 0;
  TypeLevel4_type4: any = 0;
  TypeLevel4_type5: any = 0;
  TypeLevel4_type6: any = 0;
  TypeLevel4_type7: any = 0;

  CoopTypeLevelCount: any;
  viewer: any;
  defect_data = [];
  defect_on = false;
  auth_data: any;

  ViewOAE_1: any;
  ViewOAE_2: any;
  ViewOAE_3: any;
  ViewOAE_1_detail: any;
  ViewOAE_2_detail: any;
  ViewOAE_3_detail: any;
  rubber_sum: any;

  select_title: any;
  show_title: any;
  head_title: any;

  yearData = callable.checkYearNow();
  
  listYear = callable.listYear();
  listsector = callable.getMasterSector();
  sector_now = callable.getCurrentSector();

  async ngOnInit(): Promise<void> {
    this.SpinnerService.show();
    // this.verify_role();
    this.get_auth_verify();
    await this.GetPhakList();
    await this.GetKhetList();
    await this.GetProvinceList();
    this.Info = true;
    this.TypeCoop = true;
    this.year_now = ((new Date()).getFullYear() - 1) + 543;
    this.year_now_ = ((new Date()).getFullYear()) + 543;
    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now + 1;

    registerLocaleData(he);

    if (this.Month_now == '1') {
      this.Month_now_ = "มกราคม";
    }
    else if (this.Month_now == '2') {
      this.Month_now_ = "กุมภาพันธ์";
    }
    else if (this.Month_now == '3') {
      this.Month_now_ = "มีนาคม";
    }
    else if (this.Month_now == '4') {
      this.Month_now_ = "เมษายน";
    }
    else if (this.Month_now == '5') {
      this.Month_now_ = "พฤษภาคม";
    }
    else if (this.Month_now == '6') {
      this.Month_now_ = "มิถุนายน";
    }
    else if (this.Month_now == '7') {
      this.Month_now_ = "กรกฏาคม";
    }
    else if (this.Month_now == '8') {
      this.Month_now_ = "สิงหาคม";
    }
    else if (this.Month_now == '9') {
      this.Month_now_ = "กันยายน";
    }
    else if (this.Month_now == '10') {
      this.Month_now_ = "ตุลาคม";
    }
    else if (this.Month_now == '11') {
      this.Month_now_ = "พฤศจิกายน";
    }
    else if (this.Month_now == '12') {
      this.Month_now_ = "ธันวาคม";
    }

  }

  async selectNewYearAndSector(year, sector) {
    this.SpinnerService.show();
    if (year) {
      this.year_now = callable.getCurrentYear(year);
    }

    if (sector) {
      this.sector_now = callable.getCurrentSector(sector);
    }

    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now_;

    sessionStorage.setItem(session_year, this.year_now);
    this.yearData = callable.checkYearNow();

    await this.GetPhakList();
    await this.GetKhetList();
    await this.GetProvinceList();
    this.Info = true;
    this.TypeCoop = true;
    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now + 1;

    registerLocaleData(he);

    if (this.Month_now == '1') {
      this.Month_now_ = "มกราคม";
    }
    else if (this.Month_now == '2') {
      this.Month_now_ = "กุมภาพันธ์";
    }
    else if (this.Month_now == '3') {
      this.Month_now_ = "มีนาคม";
    }
    else if (this.Month_now == '4') {
      this.Month_now_ = "เมษายน";
    }
    else if (this.Month_now == '5') {
      this.Month_now_ = "พฤษภาคม";
    }
    else if (this.Month_now == '6') {
      this.Month_now_ = "มิถุนายน";
    }
    else if (this.Month_now == '7') {
      this.Month_now_ = "กรกฏาคม";
    }
    else if (this.Month_now == '8') {
      this.Month_now_ = "สิงหาคม";
    }
    else if (this.Month_now == '9') {
      this.Month_now_ = "กันยายน";
    }
    else if (this.Month_now == '10') {
      this.Month_now_ = "ตุลาคม";
    }
    else if (this.Month_now == '11') {
      this.Month_now_ = "พฤศจิกายน";
    }
    else if (this.Month_now == '12') {
      this.Month_now_ = "ธันวาคม";
    }

    if (this.PhakId != "null") {
      this.searchPhak();
    } else if(this.OrgOrgId != "null") {
      this.searchProvince();
    } else if (this.KhetId != "null") {
      this.searchKhet();
    }

    setTimeout(() => {
      this.SpinnerService.hide();
      // sessionStorage.removeItem(session_year);
    }, 1000);
  }

  verify_role() {
    let user = JSON.parse(localStorage.getItem("access_token"));
    if (user && user['role'] == 'Admin') {
      // this.router.navigate(["/user-management"]);
      window.location.assign("/user-management")
    }
  }

  get_auth_verify() {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
    if (this.auth_data != null) {
      this.AuthenService.Get_manage_role(this.auth_data['role']).subscribe(
        responce => {
          if (this.auth_data['role'] == 'Admin') {
            this.defect_on = true;
          } else {
            for (let i = 0; i < responce.length; i++) {
              if (responce[i]['menu'] == 'ข้อบกพร่อง' && responce[i]['status'] == 'y') {
                this.defect_on = true;
              }
            }
          }
        }
      );
    }
  }

  get_date_now_and_after() {
    let Date_today = new Date();
    this.Date_after_day = new Date(Date_today);
    this.Date_after_day.setDate(this.Date_after_day.getDate() - 1);
    this.Month_now = this.Date_after_day.getMonth() + 1;
    this.Date_now = Date_today.getDate()
    this.Date_after_day = this.Date_after_day.getDate()
  }

  async SearchName() {
    this.SpinnerService.show();
    this.selectPhak = false;
    await this.GetPhakList();
    await this.GetKhetList();
    await this.GetProvinceList();
    if (this.CoopNameTh != "" && this.CoopNameTh != null && this.CoopNameTh != undefined) {
      this.searchName_ = true;
      this.CoopStatusProvinceYearBySearch = null;

      this.FamerServiceService.GetAgriProfilesAll(this.CoopNameTh).subscribe(res => {
        this.CoopProfileAll = res;
        for (let i = 0; i < res.length; i++) {
          this.coopId = res[i].agriId;
          this.sumResult = res.length;
          sessionStorage.setItem('coopId', this.coopId);
        }
        this.SpinnerService.hide();
      });
    } else {
      Swal.fire('Warnning', 'กรุณากรอกข้อมูลที่ต้องการค้นหา', 'warning');
      this.SpinnerService.hide();
    }
  }

  GetPhakList() {
    // this.SpinnerService.show();
    return new Promise(async (resolve, reject) => {
      this.CoopServiceService.GetPhakList().subscribe(res => {
        this.PhakList = res;
        resolve("OK");
      });
    });
  }

  GetKhetList() {
    return new Promise(async (resolve, reject) => {
      this.CoopServiceService.GetKhetList().subscribe(res => {
        this.checkkhet = res;
        resolve("OK");
      });
    });
  }

  GetProvinceList() {
    return new Promise(async (resolve, reject) => {
      this.CoopServiceService.GetProvinceList().subscribe(res => {
        this.ProvinceByKhet = res;
        resolve("OK");
      });
    });
  }

  searchPhak() {
    this.SpinnerService.show();
    this.head_title = 'ภาค';
    this.show_title = this.select_title;
    this.listCoop = null;
    this.searchName_ = false;
    this.KhetId = "null";
    this.OrgOrgId = "null";
    this.selectPhak = true;
    this.CoopNameTh = null;
    this.GetAgriOracleCountNEW();
    this.GetAgriMemberEachProvinceLastestYear();
    this.GetAgriCommiteeProvinceYearBySearch();
    this.GetAgriSumOfficer();
    this.GetAgriStandardTypeSum();
    this.GetAgriOracleTypesNew();
    this.GetAgriStatusProvinceYearBySearch();
    this.GetAgriList();
    this.GetKhetList();
    this.GetProvinceList();
    // this.GetCoopTypeLevelCount();
    // this.GetDefectProvinceYearSum();
    // this.GetViewOAEByGroup();
    // this.GetViewRubberSumProvinceTotal();
    this.viewgraph();
    this.get_viewer_phak();
  }

  searchKhet() {
    this.SpinnerService.show();
    this.head_title = '';
    this.show_title = this.select_title;
    this.searchName_ = false;
    this.PhakId = "null";
    this.OrgOrgId = "null";
    this.listCoop = null;
    this.selectPhak = true;
    this.CoopNameTh = null;
    this.GetAgriOracleCountNEW();
    this.GetAgriMemberEachProvinceLastestYear();
    this.GetAgriCommiteeProvinceYearBySearch();
    this.GetAgriSumOfficer();
    this.GetAgriStandardTypeSum();
    this.GetAgriOracleTypesNew();
    this.GetAgriStatusProvinceYearBySearch();
    this.GetAgriList();
    this.GetPhakList();
    this.GetProvinceList();
    // this.GetCoopTypeLevelCount();
    // this.GetDefectProvinceYearSum();
    // this.GetViewOAEByGroup();
    // this.GetViewRubberSumProvinceTotal();
    this.viewgraph();
    this.get_viewer_khet();
  }

  searchProvince() {
    this.SpinnerService.show();
    this.head_title = 'จังหวัด';
    this.show_title = this.select_title;
    this.listCoop = null;
    this.searchName_ = false;
    this.PhakId = "null";
    this.KhetId = "null";
    this.selectPhak = true;
    this.CoopNameTh = null;
    this.GetAgriOracleCountNEW();
    this.GetAgriMemberEachProvinceLastestYear();
    this.GetAgriCommiteeProvinceYearBySearch();
    this.GetAgriSumOfficer();
    this.GetAgriStandardTypeSum();
    this.GetAgriOracleTypesNew();
    this.GetAgriStatusProvinceYearBySearch();
    this.GetAgriList();
    this.GetKhetList();
    this.GetPhakList();
    // this.GetCoopTypeLevelCount();
    // this.GetDefectProvinceYearSum();
    // this.GetViewOAEByGroup();
    // this.GetViewRubberSumProvinceTotal();
    this.viewgraph();
    this.get_viewer_province();
  }

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }

  onChangePagelistCoop(pageOfItemslistCoop: Array<any>) {
    // update current page of items
    this.pageOfItemslistCoop = pageOfItemslistCoop;
  }

  GetAgriOracleCountNEW() {
    return new Promise(async (resolve, reject) => {
      this.FamerServiceService.GetAgriOracleCountNEW(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        this.CoopOracleCount =0;
        this.CoopOracleCountactive =0;
        this.CoopOracleCountnonActive =0;

        for (let i = 0; i < res.length; i++) {
          this.CoopOracleCount += res[i].coopCount;
          this.CoopOracleCountactive += res[i].active;
          this.CoopOracleCountnonActive += res[i].nonActive;
        }
        resolve("OK");
      });
    });
  }

  GetAgriMemberEachProvinceLastestYear() {
    // this.SpinnerService.show();
    return new Promise(async (resolve, reject) => {
      this.FamerServiceService.GetAgriSumMemberNew(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        this.MemberSum = 0;
        this.MemberDataM = 0;
        this.MemberDataFm = 0;
        for (let i = 0; i < res.length; i++) {
          this.MemberSum += res[i].sum;
          this.MemberDataM += res[i].dataFm;
          this.MemberDataFm += res[i].dataM;
        }
        resolve("OK");
      });
    });
  }

  GetAgriCommiteeProvinceYearBySearch() {
    return new Promise(async (resolve, reject) => {
      this.FamerServiceService.GetAgriSumCommitteeNew(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        this.CommitteeSum =0;
        this.CommitteeSumM =0;
        this.CommitteeSumFm =0;

        for (let i = 0; i < res.length; i++) {
          this.CommitteeSum += res[i].sum;
          this.CommitteeSumM += res[i].dataM;
          this.CommitteeSumFm += res[i].dataFm;

        }
        resolve("OK");
      });
    });
  }

  GetAgriSumOfficer() {
    return new Promise(async (resolve, reject) => {
      this.FamerServiceService.GetAgriSumOfficer(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        this.CoopOfficerYearMember = 0;
        this.CoopOfficerYearMemberM = 0;
        this.CoopOfficerYearMemberFm = 0;

        for (let i = 0; i < res.length; i++) {
          this.CoopOfficerYearMember += res[i].sum;
          this.CoopOfficerYearMemberM += res[i].dataM;
          this.CoopOfficerYearMemberFm += res[i].dataFm;
        }
        resolve("OK");
      });
    });
  }

  GetAgriStandardTypeSum() {
    return new Promise(async (resolve, reject) => {
      this.FamerServiceService.GetAgriStandardTypeSum(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        this.StandardTypeSum_pass =0
        this.StandardTypeSum_notPass =0

        for (let i = 0; i < res.length; i++) {

          this.StandardTypeSum_pass += res[i].pass;
          this.StandardTypeSum_notPass += res[i].notPass;

          if (res[i].coopType == "1") {
            this.StandardType_pass_level1 = res[i].pass;
            this.StandardType_notPass_level1 = res[i].notPass;
          }
          else if (res[i].coopType == "2") {
            this.StandardType_pass_level2 = res[i].pass;
            this.StandardType_notPass_level2 = res[i].notPass;
          }
          else if (res[i].coopType == "3") {
            this.StandardType_pass_level3 = res[i].pass;
            this.StandardType_notPass_level3 = res[i].notPass;
          }
          else if (res[i].coopType == "4") {
            this.StandardType_pass_level4 = res[i].pass;
            this.StandardType_notPass_level4 = res[i].notPass;
          }
          else if (res[i].coopType == "5") {
            this.StandardType_pass_level5 = res[i].pass;
            this.StandardType_notPass_level5 = res[i].notPass;
          }
          else if (res[i].coopType == "6") {
            this.StandardType_pass_level6 = res[i].pass;
            this.StandardType_notPass_level6 = res[i].notPass;
          }
        }
        resolve("OK");
      });
    });
  }

  selectProvice_Search(event) {
    this.OrgOrgId = this.pageOfItems[event].orgOrgId;
    // this.OrgOrgId = event;
    this.PhakId = "null";
    this.KhetId = "null";

    this.SpinnerService.show();

    if (this.PhakId != undefined && this.KhetId != undefined && this.OrgOrgId != undefined) {
      this.FamerServiceService.GetAgriList(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

        this.listCoop = res;
        for (let i = 0; i < res.length; i++) {
          this.listCoop[i]['member'] = 0
          this.listCoop[i]['member'] = this.listCoop[i]['member'] + res[i].memberFm;
          this.listCoop[i]['member'] = this.listCoop[i]['member'] + res[i].memberM;
        }
        this.sumResult_ = res.length;

      });
      this.selectProviceSearch = true;

    } else {
      Swal.fire('Warnning', 'กรุณาเลือกข้อมูลที่ต้องการค้นหา', 'warning');
    }
    this.SpinnerService.hide();


  }

  GetAgriOracleTypesNew() {
    return new Promise(async (resolve, reject) => {
      this.FamerServiceService.GetAgriOracleTypesNew(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        this.CoopOracleTypes = res;
        this.Active_coopType1 =0
        this.InActive_coopType1 =0

        for (let i = 0; i < res.length; i++) {

          this.Active_coopType1 += res[i].active
          this.InActive_coopType1 += res[i].nonActive
          if (res[i].coopType == "1") {
            this.typeName = "กลุ่มเกษตรกรทำนา";
          }
          else if (res[i].coopType == "2") {
            this.typeName = "กลุ่มเกษตรกรทำไร่";
          }
          else if (res[i].coopType == "3") {
            this.typeName = "กลุ่มเกษตรกรทำสวน";
          }
          else if (res[i].coopType == "4") {
            this.typeName = "กลุ่มเกษตรกรประมง";
          }
          else if (res[i].coopType == "5") {
            this.typeName = "กลุ่มเกษตรกรเลี้ยงสัตว์";
          }
          else if (res[i].coopType == "6") {
            this.typeName = "กลุ่มเกษตรกรอื่นๆ";
          }
          // else if (res[i].coopType == "7") {
          //   this.typeName = "สหกรณ์เครดิตยูเนี่ยน";
          // }
        }
        resolve("OK");
      });
    });
  }

  setphak(event) {
    this.PhakId = event;
    this.OrgOrgId = "null";
    this.KhetId = "null";
    const temp = this.PhakList.filter(x => x.phakId == event);
    this.select_title = temp[0]['phakName']

  }

  setkhet(event) {
    this.KhetId_ = event;
    this.KhetId = this.KhetId_;
    this.PhakId = "null";
    this.OrgOrgId = "null";
    const temp = this.checkkhet.filter(x => x.khet_id == event);
    this.select_title = temp[0]['khet_desc']
  }

  setProvince(event) {
    this.OrgOrgId = event;
    this.KhetId = "null";
    this.PhakId = "null";
    const temp = this.ProvinceByKhet.filter(x => x.orgOrgId == event);
    this.select_title = temp[0]['provinceNameSort']
  }

  get_viewer_phak() {
    let count;
    this.ViewerService.Get_viewerAll('Serach_Phak').subscribe(
      responce => {
        this.viewer = responce[0].count + 1;
        count = parseInt(this.viewer);
        this.viewer = this.viewer.toLocaleString();
        this.ViewerService.Update_viewerCount(responce[0].id, count).subscribe(
          responce => {
          }
        )
      }
    );
  }

  get_viewer_khet() {
    let count;
    this.ViewerService.Get_viewerAll('Search_Khet').subscribe(
      responce => {
        this.viewer = responce[0].count + 1;
        count = parseInt(this.viewer);
        this.viewer = this.viewer.toLocaleString();
        this.ViewerService.Update_viewerCount(responce[0].id, count).subscribe(
          responce => {
          }
        )
      }
    );
  }

  get_viewer_province() {
    let count;
    this.ViewerService.Get_viewerAll('Search_Province').subscribe(
      responce => {
        this.viewer = responce[0].count + 1;
        count = parseInt(this.viewer);
        this.viewer = this.viewer.toLocaleString();
        this.ViewerService.Update_viewerCount(responce[0].id, count).subscribe(
          responce => {
          }
        )
      }
    );
  }

  GetAgriStatusProvinceYearBySearch() {
    this.SpinnerService.show();
    this.FamerServiceService.GetAgriStatusProvinceYearBySearch(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

      this.CoopStatusProvinceYearBySearch = Array(res.length).fill(0).map((x, i) => ({ id: res[i].id, provinceName: res[i].provinceName, active: res[i].active, nonActive: res[i].nonActive, sum: res[i].sum, orgOrgId: res[i].orgOrgId }));
      this.sumResult = res.length;
      this.CoopStatusProvinceYearOne = res;

    });
    this.SpinnerService.hide();
  }

  GetAgriList() {
    this.FamerServiceService.GetAgriList(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      // this.listCoop = res;
      this.listCoop = Array(res.length).fill(0).map((x, i) => ({ id: res[i].id, coopNameTh: res[i].coopNameTh, registryNo2: res[i].registryNo2, stdCode: res[i].stdCode, coopId: res[i].coopId }));
      this.sumResult_ = res.length;
    });
  }

  select_Info(data) {
    this.Info = data;
    if (this.Info == "Info") {
      this.Info = true;
      this.List = false;
    }

    this.viewgraph();
  }

  select_List(data) {
    this.SpinnerService.show();
    this.List = data;
    if (this.List == "List") {
      this.Info = false;
      this.List = true;
    }

    // this.viewgraph();
    this.SpinnerService.hide();
  }

  selectCoopProfile(event, check) {
    if (check == 1) {
      this.coopId = this.CoopProfileAll[event].agriId;
    } else if (check == 2) {
      this.coopId = this.pageOfItemslistCoop[event].agriId;
    }

    if (this.coopId != undefined) {
      sessionStorage.setItem('coopId', this.coopId);
      this.router.navigate(["/ProfileAgri"]);
    }
    if (this.coopId == undefined) {
      Swal.fire('Warnning', 'กำลังโหลดข้อมูล กรุณาเลือกอีกครั้ง', 'warning');
    }
  }

  viewgraph() {
    // ngAfterViewInit() {

    this.zone.runOutsideAngular(() => {
      this.FamerServiceService.GetAgriOracleCountNEW(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        res = callable.shiftYear(res, this.yearData);
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_AN_insert", am4charts.XYChart);
        let data = [];
        let year_now = this.year_now;

        chart.logo.disabled = true; //ลบโลโก้ของ am4charts

        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis()); //แนวแกน y แนวตั้ง
        categoryAxis.dataFields.category = "year"; // เลือกเอา ตัวแปร year มาเป็นแกน y
        categoryAxis.renderer.labels.template.disabled = true; // ปิดข้อความแกน แกน y
        categoryAxis.renderer.grid.template.opacity = 0;
        categoryAxis.fontSize = "11px" // ฟอนต์ข้อความ 

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis()); //แนวแกน x แนวนอน
        valueAxis.min = 0; // เริ่มต้นที่ 0
        valueAxis.renderer.grid.template.opacity = 0;
        valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
        valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
        valueAxis.renderer.ticks.template.length = 10;
        valueAxis.renderer.line.strokeOpacity = 0.5;
        valueAxis.renderer.baseGrid.disabled = true;
        valueAxis.renderer.minGridDistance = 40;
        valueAxis.fontSize = "11px"

        // Create series
        function createSeries(field, name, color) {
          let series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueX = field;
          series.dataFields.categoryY = "year";
          series.stacked = true;
          series.name = name;
          series.columns.template.propertyFields.fill = color;
          series.columns.template.propertyFields.stroke = color;

          let columnTemplate = series.columns.template;
          columnTemplate.strokeWidth = 2;
          columnTemplate.strokeOpacity = 1;
          series.columns.template.propertyFields.fill = color;
          series.columns.template.propertyFields.stroke = color;

          let labelBullet = series.bullets.push(new am4charts.LabelBullet());
          labelBullet.locationX = 0.5;
          labelBullet.label.text = "{valueX}";
          labelBullet.label.fill = am4core.color("#fff");

        }

        chart.legend = new am4charts.Legend();
        for (let i = 0; i < res.length; i++) {
          // Add data
          data.push(
            {
              "year": year_now,
              "active": res[i].active,
              "nonactive": res[i].nonActive
            }
          )
        }
        chart.data = data;
        chart.logo.disabled = true;
        createSeries("active", "Active", "#4f9f0c");
        createSeries("nonactive", "Non-active", "#aa1107");

      })
    })

    // มาตรฐานสหกรณ์
    this.zone.runOutsideAngular(() => {
      this.FamerServiceService.GetAgriStandardTypeSum(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        this.StandardTypeSum_pass =0;
        this.StandardTypeSum_notPass =0;
        for (let i = 0; i < res.length; i++) {

          this.StandardTypeSum_pass += res[i].pass;
          this.StandardTypeSum_notPass += res[i].notPass;

          if (res[i].coopType == "1") {
            this.StandardType_pass_level1 = res[i].pass;
            this.StandardType_notPass_level1 = res[i].notPass;
          }
          else if (res[i].coopType == "2") {
            this.StandardType_pass_level2 = res[i].pass;
            this.StandardType_notPass_level2 = res[i].notPass;
          }
          else if (res[i].coopType == "3") {
            this.StandardType_pass_level3 = res[i].pass;
            this.StandardType_notPass_level3 = res[i].notPass;
          }
          else if (res[i].coopType == "4") {
            this.StandardType_pass_level4 = res[i].pass;
            this.StandardType_notPass_level4 = res[i].notPass;
          }
          else if (res[i].coopType == "5") {
            this.StandardType_pass_level5 = res[i].pass;
            this.StandardType_notPass_level5 = res[i].notPass;
          }
          else if (res[i].coopType == "6") {
            this.StandardType_pass_level6 = res[i].pass;
            this.StandardType_notPass_level6 = res[i].notPass;
          }
          // else if (res[i].coopType == "7") {
          //   this.StandardType_pass_level7 = res[i].pass;
          //   this.StandardType_notPass_level7 = res[i].notPass;
          // }
        }

        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_Standard_insert", am4charts.PieChart);
        chart.hiddenState.properties.opacity = 0;

        let data = [];
        let sum_standard_pass_
        let sum_standard_not_

        sum_standard_pass_ = this.StandardTypeSum_pass;
        sum_standard_not_ = this.StandardTypeSum_notPass;

        data.push(
          {
            "country": "ผ่านมาตรฐาน",
            "value": sum_standard_pass_,
            "color": am4core.color("#44c70d")
          },
          {
            "country": "ไม่ผ่านมาตรฐาน",
            "value": sum_standard_not_,
            "color": am4core.color("#ca0000")
          }
        )

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "มาตรฐานกลุ่มเกษตรกร";
        title.disabled = false;

        chart.data = data;
        chart.logo.disabled = true;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "มาตรฐานกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        let series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "value";
        // series.dataFields.radiusValue = "value";
        series.dataFields.category = "country";
        series.slices.template.cornerRadius = 6;
        series.colors.step = 2;
        series.slices.template.propertyFields.fill = "color";
        series.hiddenState.properties.endAngle = -90;

        // เพิ่มตัวเลขในวงกลม
        series.alignLabels = false;
        series.ticks.template.disabled = true;
        series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
        series.labels.template.radius = am4core.percent(-90);
        series.labels.template.fill = am4core.color("black");
        series.labels.template.relativeRotation = 90;

        // เปลี่ยนเปอร์เซ็นต์เป็นตัวเลข
        series.calculatePercent = true;
        series.labels.template.text = "{category}: {value.value}";
        series.slices.template.tooltipText = "{category}: {value.value}";

        chart.legend = new am4charts.Legend();
      })
    })


    this.FamerServiceService.GetAgriFinanceNew(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // สินทรัพย์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_asset_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].net_asset && res[i].year != '2558') {

            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // หนี้สิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_debt_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].liabilities && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"
        valueAxis.min = 0;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ทุน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_Capital_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_capital && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"
        valueAxis.min = 0;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // กำไร
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_profit_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].net_profit && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)ของกลุ่มเกษตรกร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)ของกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    })

    this.FamerServiceService.GetAgriFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type1_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type2_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;
      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type3_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type4_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type5_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type6_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      //หนี้สินของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type1_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type2_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type3_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type4_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type5_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type6_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      //ทุนของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type1_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type2_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type3_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_Capital_type4_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type5_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type6_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      //กำไรของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_profit_type1_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type2_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type3_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type4_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type5_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type6_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })
    })

    // ปริมาณธุรกิจ
    this.FamerServiceService.GetAgriBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // เก่า model
      // ปริมารธุรกิจ รับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_deposit_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].deposit_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ ให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_lend_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].credit_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ จัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_products_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sale_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ รวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_produce_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].collect_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"


        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ แปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_Processing_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].transfrom_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net


        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ บรืการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_service_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";

        for (let i = 0; i < res.length; i++) {
          if (res[i].service_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net


        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[0].year) {
            this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum1 = this.valSum1
            data.push({
              "year": res[i].year,
              "value": valSum1
            })
          }
          else if (res[1].year) {
            this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum2 = this.valSum2
            data.push({
              "year": res[i].year,
              "value": valSum2
            })
          }
          else if (res[2].year) {
            this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum3 = this.valSum3

            data.push({
              "year": res[i].year,
              "value": valSum3
            })
          }
          else if (res[3].year) {
            this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum4 = this.valSum4

            data.push({
              "year": res[i].year,
              "value": valSum4
            })
          }
          else if (res[4].year) {
            this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum5 = this.valSum5
            data.push({
              "year": res[i].year,
              "value": valSum5
            })
          }

        }

        chart.data = data;
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    })


    this.FamerServiceService.GetAgriBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ เกษตร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_business_type1_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ปริมาณธุรกิจ เกษตร ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ปริมาณธุรกิจ เกษตร ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำนา ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจประเภทกลุ่มเกษตรกรทำไร่ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')


      })

      // ปริมาณธุรกิจ นิคม ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทจัดหา
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้าน้คา ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรวบรวม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรวบรวม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรวบรวม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรวบรวม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type1_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '1') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5

              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }
          }

        }

        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ประมง
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type2_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '2') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1

              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }
        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ นิคม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type3_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '3') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }
          }

        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ออมทรัพย์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type4_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '4') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4

              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ร้านค้า
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type5_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '5') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ บริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type6_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '6') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ เครดิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type7_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '7') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

    });


    // การมีส่วนร่วมของสมาชิกสหกรณ์
    this.FamerServiceService.GetAgriProfileBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      am4core.useTheme(am4themes_animated);
      let chart = am4core.create("chartdiv_Participation_coop_sum_insert", am4charts.XYChart);
      chart.scrollbarX = new am4core.Scrollbar();

      let data = [];

      for (let i = 0; i < res.length; i++) {
        if (res[i].year != '2558') {
          data.push(
            {
              "year": res[i].year,
              "value": res[i].sum_member
            }
          )
        }
      }

      chart.data = data;
      chart.logo.disabled = true;
      // Export
      let title = chart.titles.create();
      title.fontSize = "11px";
      title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร";
      title.disabled = false;
      chart.exporting.menu = new am4core.ExportMenu();
      chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร";
      chart.exporting.useWebFonts = false;
      chart.exporting.validateSprites.push(title);
      chart.exporting.validateSprites.push(title.parent);
      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "year";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.rotation = 270;
      categoryAxis.tooltip.disabled = true;

      categoryAxis.fontSize = "11px"
      // categoryAxis.title.text = "ปีข้อมูล"

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.minWidth = 50;
      valueAxis.fontSize = "11px"
      valueAxis.title.text = "หน่วย : คน"

      // Create series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.sequencedInterpolation = true;
      series.dataFields.valueY = "value";
      series.dataFields.categoryX = "year";
      series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
      series.columns.template.strokeWidth = 0;

      series.tooltip.pointerOrientation = "vertical";

      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.columns.template.column.fillOpacity = 0.8;

      let bullet = series.bullets.push(new am4charts.LabelBullet())
      bullet.interactionsEnabled = false
      bullet.dy = -10;
      bullet.label.text = '{valueY}'
      bullet.label.fill = am4core.color('#000')

      // on hover, make corner radiuses bigger
      let hoverState = series.columns.template.column.states.create("hover");
      hoverState.properties.cornerRadiusTopLeft = 0;
      hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 1;

      series.columns.template.adapter.add("fill", function (fill, target) {
        return chart.colors.getIndex(target.dataItem.index);
      });

      chart.logo.disabled = true;
      // Cursor
      chart.cursor = new am4charts.XYCursor();

    })

    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ การเกษตร
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_coop_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประมง
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_fishing_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ นิคม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_Settlement_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ออมทรัพย์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_saving_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ร้านค้า
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_shop_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ บริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_service_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

    })

  }

  ngOnDestroy() {
    // Clean up chart when the component is removed

    this.zone.runOutsideAngular(() => {

      am4core.disposeAllCharts();

    });
  }

  Participationinsert() {
    this.FamerServiceService.GetAgriProfileBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_deposit && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_credit) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_sale && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_good && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }


        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_marketing && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }
        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_service && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_other && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }
        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของกลุ่มเกษตรกร ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation1insert() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำนา ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation2insert() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำไร่";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation3insert() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวนประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรทำสวน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation4insert() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรประมง";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation5insert() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation6insert() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6" && res[i].year != '2558') {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของประเภทกลุ่มเกษตรกรอื่นๆ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  agri_page(url) {
    this.router.navigate(['/' + url]);
  }

}
